/* jshint -W024 */
import Roles from '@/domain/rolesEnum';
import i18n from '@/ui/i18n';

const InvestorRoutes = [
  {
    path: '/remesado',
    name: 'investor',
    parentName: 'consignments',
    meta: {
      roles: [Roles.INVESTOR, Roles.BACKOFFICE_FINANCE],
      title: i18n.t('investorRoutes.consignmented'),
      iconName: 'file-invoice-dollar'
    },
    component: () => import('@/ui/views/internal/investor/InvestorConsignments.vue')
  },
  {
    path: '/portafolios',
    parentName: 'consignments',
    name: 'my-portfolios',
    meta: {
      roles: [Roles.INVESTOR, Roles.INSTITUCIONAL_VENDOR],
      title: i18n.t('investorRoutes.myWallets'), // Mis Carteras
      iconName: 'briefcase'
    },
    component: () => import('@/ui/views/internal/my-portfolios/MyPortfolios.vue')
  }
];

export default InvestorRoutes;
